import React from 'react';
import cn from 'classnames';

import StarsIcon from 'widget/shared/icons/StarsIcon';
import { IconColor } from 'widget/shared/icons/BaseIcon';
import Typography from 'widget/shared/ui/Typography';
import {
  TypographySize,
  TypographyColor
} from 'widget/shared/ui/Typography/types';
import { WidgetTexts } from 'widget/consts/texts';

import styles from './EmptyMessages.module.scss';

export type EmptyMessagesProps = {
  className?: string;
};
const EmptyMessages: React.FC<EmptyMessagesProps> = ({ className }) => {
  return (
    <div className={cn(styles['empty-messages'], className)}>
      <StarsIcon color={IconColor.Main} />
      <Typography
        size={TypographySize.s}
        color={TypographyColor.fill}
        className={styles['empty-messages__text']}
      >
        {WidgetTexts.messageList.empty}
      </Typography>
    </div>
  );
};

export default EmptyMessages;
